export default {
  bookingList: {},
  assetList: [],
  assetInventoryList: [],
  keyContactNames: {},
  assetError: null,
  error: null,
}
